import {
  AsyncPipe,
  NgClass,
  NgFor,
  NgIf,
} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import { RouterLink } from '@angular/router';

import { Context } from '../../../../../../../../../app/core/shared/context.model';
import { ViewMode } from '../../../../../../../../../app/core/shared/view-mode.model';
import { ThemedBadgesComponent } from '../../../../../../../../../app/shared/object-collection/shared/badges/themed-badges.component';
import { ItemSearchResult } from '../../../../../../../../../app/shared/object-collection/shared/item-search-result.model';
import { listableObjectComponent } from '../../../../../../../../../app/shared/object-collection/shared/listable-object/listable-object.decorator';
import { ItemSearchResultListElementComponent as BaseComponent } from '../../../../../../../../../app/shared/object-list/search-result-list-element/item-search-result/item-types/item/item-search-result-list-element.component';
import { TruncatableComponent } from '../../../../../../../../../app/shared/truncatable/truncatable.component';
import { TruncatablePartComponent } from '../../../../../../../../../app/shared/truncatable/truncatable-part/truncatable-part.component';
import { SubjectBadgesComponent } from '../../../../../object-collection/shared/badges/subject-badges/subject-badges.component';
import { ThemedThumbnailComponent } from '../../../../../../../../../app/thumbnail/themed-thumbnail.component';

@listableObjectComponent('PublicationSearchResult', ViewMode.ListElement, Context.Any, 'bfs')
@listableObjectComponent(ItemSearchResult, ViewMode.ListElement, Context.Any, 'bfs')
@Component({
  selector: 'ds-item-search-result-list-element',
  styleUrls: [
    '../../../../../../../../../app/shared/object-list/search-result-list-element/item-search-result/item-types/item/item-search-result-list-element.component.scss',
    './item-search-result-list-element.component.scss',
  ],
  templateUrl: './item-search-result-list-element.component.html',
  // templateUrl: '../../../../../../../../../app/shared/object-list/search-result-list-element/item-search-result/item-types/item/item-search-result-list-element.component.html',
  standalone: true,
  imports: [NgIf, RouterLink, ThemedThumbnailComponent, NgClass, ThemedBadgesComponent, TruncatableComponent, TruncatablePartComponent, NgFor, AsyncPipe, SubjectBadgesComponent],

})
export class ItemSearchResultListElementComponent extends BaseComponent implements OnInit {
  publicationYear: string;

  ngOnInit(): void {
    super.ngOnInit()

    const issuedDate = this.dso.firstMetadataValue('dc.date.issued');
    if (issuedDate) {
      this.publicationYear = this.extractPublicationYear(issuedDate);
    }
  }

  /**
   * BfS: Jahr bzw. Zeitraum aus dc.date.issued, z.B. "23.04.2035" -> "2035", "2019 - 2020" -> "2019 - 2020".
   */
  private extractPublicationYear(value: string): string {
    const years = value.match(/(?<!\d)\d{4}(?!\d)/g);
    if (!years) {
      return value;
    }
    const unique = years.filter((y, i) => years.indexOf(y) === i);
    return unique.length > 1 ? `${unique[0]} - ${unique[unique.length - 1]}` : unique[0];
  }

  /**
   * BfS: Personennamen (dc.creator, dc.contributor.author) von "Nachname, Vorname" in "Vorname Nachname" umwandeln.
   * Körperschaften (dc.publisher, dc.contributor) bleiben unverändert.
   */
  formatName(value: string): string {
    const persons = this.dso.allMetadataValues(['dc.creator', 'dc.contributor.author']);
    const [lastname, ...firstname] = value.split(',');
    if (!persons.includes(value.replace(/<\/?em>/g, '')) || firstname.length === 0) {
      return value;
    }
    return `${firstname.join(',').trim()} ${lastname.trim()}`;
  }
}
